import { getItem } from './session-storage';

// A MUM user's selected account is persisted under `mumHost` in sessionStorage
// (shared same-origin with host) so the selection follows them across pages.
// Read it through this helper so every consumer uses the same storage backend
// and the same defensive parse — a corrupted/legacy value returns null rather
// than throwing and blanking the page.
export function getMumHost() {
  const stored = getItem('mumHost');
  if (!stored) return null;

  try {
    return JSON.parse(stored);
  }
  catch (error) {
    return null;
  }
}

// The selected MUM account id, or `fallback` when no valid account is stored.
// Guards against a parsed object that is missing `id` (which would otherwise
// leave hostId undefined and break downstream queries).
export function getMumHostId(fallback = null) {
  const mumHost = getMumHost();
  return mumHost && mumHost.id ? mumHost.id : fallback;
}



// WEBPACK FOOTER //
// ./src/lib/mum-host.js